import { get } from 'lodash'
import { AWARD_MODES } from '../../constants/enums'
import moment from 'moment/moment'

export const headers = (intl = {}) => [
  intl.formatMessage({
    id: 'table.id'
  }),
  intl.formatMessage({
    id: 'table.first_name'
  }),
  intl.formatMessage({
    id: 'table.last_name'
  }),
  intl.formatMessage({
    id: 'table.email'
  }),
  intl.formatMessage({
    id: 'award.levels'
  }),
  intl.formatMessage({
    id: 'table.last_log_added'
  }),
  intl.formatMessage({
    id: 'table.labels'
  }),
  intl.formatMessage({
    id: 'table.award_labels'
  }),
  intl.formatMessage({
    id: 'table.award_leader'
  }),
  intl.formatMessage({
    id: 'table.award_unit'
  }),
  intl.formatMessage({
    id: 'table.country'
  }),
  intl.formatMessage({
    id: 'table.participant_state'
  })
]

export const line = (data = []) =>
  data.map(item => {
    const awardModeType = get(item, 'award.mode.type')
    const lastLogDate = get(item, 'person.lastLogDate')

    let modeOrLastLog

    if (awardModeType === AWARD_MODES.offline.id) {
      modeOrLastLog = 'Offline'
    } else if (lastLogDate) {
      modeOrLastLog = moment(lastLogDate).fromNow()
    } else {
      modeOrLastLog = 'No logs'
    }

    return {
      line: [
        `${get(item, 'person.globalId')}`,
        `${get(item, 'person.firstName')}`,
        `${get(item, 'person.lastName')}`,
        `${get(item, 'person.email')}`,
        `Bronze:${get(item, 'person.hasBronzeAward')} Silver:${get(item, 'person.hasSilverAward')} Gold: ${get(item, 'person.hasGoldAward')}`,
        `${modeOrLastLog}`,
        `${get(item, 'person.labels').map(label => label.name).join(', ')}`,
        `${get(item, 'award.labels').map(label => label.name).join(', ')}`,
        `${get(item, 'awardLeader.name')}`,
        `${get(item, 'award.organization.name')}`,
        `${get(item, 'award.organization.nao.name')}`,
        `${get(item, 'award.state.type') && get(item, 'award.state.value')}`
      ]
    }
  })
